// set strict mode to true

(function ($) {
  const siteUrl = bmtg_bundle_object.siteurl;
  // var themeUrl = siteUrl + "/wp-content/themes/bmtg";

  // Local Storage Test
  function localStorageTest() {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  // if local storage is available
  if (localStorageTest()) {
    // get html lang
    function get_locale() {
      const locale = $('html').attr('lang');
      return locale;
    }

    // language variables
    let merken = 'Merken';
    let gemerkt = 'Gemerkt';
    if (get_locale() !== 'de-DE') {
      merken = 'Save';
      gemerkt = 'Saved';
    }

    let favorites = [];
    favorites = JSON.parse(localStorage.getItem('favorites'));
    let existsInFavorites = false;

    let favoritesCount = 0;
    if (favorites) {
      favoritesCount = favorites.length;
      $('.favorite-count').text(` (${favoritesCount})`);
    }

    function like() {
      $('.heart').addClass('heart-liked');
      $('.merken').addClass('gemerkt');
      $('.merken').text(gemerkt);
      favoritesCount += 1;
      $('.favorite-count').text(` (${favoritesCount})`);
    }

    function unlike() {
      $('.heart').removeClass('heart-liked');
      $('.merken').removeClass('gemerkt');
      $('.merken').text(merken);
      favoritesCount -= 1;
      $('.favorite-count').text(` (${favoritesCount})`);
    }

    // get data-title and url
    const favoritesId = $('.user-favorites').data('id');
    const favoritesTitle = $('.user-favorites').data('title');
    const favoritesUrl = $('.user-favorites').data('url');
    // check if url of this page already exists in local storage

    if (favorites) {
      for (let i = 0; i < favorites.length; i++) {
        if (favorites[i].id === favoritesId) {
          existsInFavorites = true;
        }
      }

      if (existsInFavorites === false) {
        $('.user-favorites').html(`
            <div class="heart"></div>
            <span class="merken">${merken}</span>
          `);
      }

      if (existsInFavorites === true) {
        $('.user-favorites').html(`        
          <div class="heart heart-liked"></div>
          <span class="merken gemerkt">${gemerkt}</span>
          `);
      }

      $('.user-favorites').on('click', (e) => {
        e.preventDefault();

        const favorites = JSON.parse(localStorage.getItem('favorites'));

        if (favorites) {
          existsInFavorites = false;
          for (let i = 0; i < favorites.length; i++) {
            if (favorites[i].id === favoritesId) {
              existsInFavorites = true;
            }
          }
        }

        // get local storage favorites
        // if favorites in storage is empty
        if (favorites === null) {
          // create new array
          const newFavorites = [{
            id: favoritesId,
            title: favoritesTitle,
            url: favoritesUrl,
            position: 1,
          }];
          // write page to favorites
          localStorage.setItem('favorites', JSON.stringify(newFavorites));
          like();
        }

        if (favorites !== null) {
          // ITEM EXISTS IN FAVORITES -> remove item
          if (existsInFavorites === true) {
            if (favorites.length <= 1) {
              // remove favorites from local storage
              localStorage.removeItem('favorites');
              // $('#user-favorites-checkbox').prop('checked', false);
              unlike();
              return;
            }

            if (favorites.length > 1) {
              // remove all items from favorites in local storage where url is equal to clicked url
              const newFavorites = favorites.filter((item) => item.url !== favoritesUrl);
              // set updated local storage
              localStorage.setItem('favorites', JSON.stringify(newFavorites));
              unlike();
            }
          }

          if (existsInFavorites !== true) {
            // ITEM DOES NOT EXIST IN FAVORITES -> push to favorites

            const newFavorite = {
              id: favoritesId,
              title: favoritesTitle,
              url: favoritesUrl,
              position: favorites.length + 1,
            };

            const newFavorites = [...favorites, newFavorite];

            // set new local storage
            localStorage.setItem('favorites', JSON.stringify(newFavorites));
            $('#user-favorites-checkbox').prop('checked', true);
            like();
          }
        }
      });
    }

    if (!favorites) {
      $('.user-favorites').on('click', (e) => {
        e.preventDefault();

        const favorites = JSON.parse(localStorage.getItem('favorites'));

        if (favorites) {
          existsInFavorites = false;
          for (let i = 0; i < favorites.length; i++) {
            if (favorites[i].id === favoritesId) {
              existsInFavorites = true;
            }
          }
        }

        // get local storage favorites
        // if favorites in storage is empty
        if (favorites === null) {
          // create new array
          const newFavorites = [{
            id: favoritesId,
            title: favoritesTitle,
            url: favoritesUrl,
            position: 1,
          }];
          // write page to favorites
          localStorage.setItem('favorites', JSON.stringify(newFavorites));
          like();
        }

        if (favorites !== null) {
          // ITEM EXISTS IN FAVORITES -> remove item
          if (existsInFavorites === true) {
            if (favorites.length <= 1) {
              // remove favorites from local storage
              localStorage.removeItem('favorites');
              // $('#user-favorites-checkbox').prop('checked', false);
              unlike();
              return;
            }

            if (favorites.length > 1) {
              // remove all items from favorites in local storage where url is equal to clicked url
              const newFavorites = favorites.filter((item) => item.url !== favoritesUrl);
              // set updated local storage
              localStorage.setItem('favorites', JSON.stringify(newFavorites));
              unlike();
            }
          }

          if (existsInFavorites !== true) {
            // ITEM DOES NOT EXIST IN FAVORITES -> push to favorites

            const newFavorite = {
              id: favoritesId,
              title: favoritesTitle,
              url: favoritesUrl,
              position: favorites.length + 1,
            };

            const newFavorites = [...favorites, newFavorite];

            // set new local storage
            localStorage.setItem('favorites', JSON.stringify(newFavorites));
            $('#user-favorites-checkbox').prop('checked', true);
            like();
          }
        }
      });
    }
  }

  // The End of it All
}(jQuery));
